import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import blackChevron from '../../../images/black-chevron-right.svg';
import pdfIcon from '../../../images/pdficon_18px.svg';

export const SlideOut = styled.div`
  position: relative;
  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    position: static;
  }
`;

export const SlideOutBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &::after {
    content: '';
    background-image: url(${blackChevron});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    transform: rotate(90deg);
    width: 16px;
    height: 12px;
  }

  &::before {
    position: absolute;
    content: '';
    display: block;
    bottom: 0;
    left: 25px;
    height: 2px;
    width: 0px;
    background-color: #ff5c0b;
    transition: width 300ms;
  }

  ${SlideOut}.is-open & {
    &::before {
      width: 20px;
    }

    &::after {
      transform: rotate(-90deg);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    display: flex;
    &::before {
      position: absolute;
      content: '';
      display: block;
      bottom: 0;
      left: 15px;
      height: 2px;
      width: 0px;
      background-color: #ff5c0b;
      transition: width 300ms;
    }

    &::after {
      transform: none;
    }

    ${SlideOut}.is-open & {
      &::before {
        width: 20px;
      }

      &::after {
        transform: none;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const SlideOutBody = styled.div`
  display: none;
  opacity: 0;

  position: relative;

  &:before {
    position: absolute;
    left: 25px;
    content: '';
    display: block;
    width: 4px;
    height: calc(100% - 6px);
    border-left: 4px solid #e6ecef;
  }

  margin-top: 6px;

  a {
    &.is-pdf {
      &:after {
        content: '';
        background-image: url(${pdfIcon});
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        height: 18px;
        width: 18px;
        margin-left: auto;
      }
    }
  }

  ${SlideOut}.is-open & {
    display: block;
    opacity: 1;
  }

  li {
    &::after {
      margin-left: 50px !important;
      width: calc(100% - 50px) !important;
    }

    p,
    a,
    button {
      padding: 15px 0 15px 50px;

      padding-left: 25px;
      margin-left: 25px;
      width: calc(100% - 25px);
    }
  }

  p,
  li {
    text-align: left;
    font-size: 14px;
    letter-spacing: -0.19px;
    line-height: 16px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    position: absolute;
    z-index: 20;
    min-width: 13.75em;
    text-align: left;
    background-clip: padding-box;
    transition: opacity 300ms;

    top: 0;

    left: 100%;
    padding-left: 16px;

    width: 100%;
    padding-left: 0;

    margin-top: 0;

    &:before {
      content: none;
    }

    li {
      p,
      a,
      button {
        padding: 10px 15px;

        padding-left: 25px;
        margin-left: 0;
        width: 100%;
      }

      p {
        padding: 15px 15px 5px 25px;
      }
    }

    li:first-child {
      p {
        padding: 10px 15px 5px 25px;
      }
    }

    p,
    li {
      font-size: 15px;
      letter-spacing: -0.2px;
      line-height: 18px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;
